// --- smooth scroll --------------

// lenis smooth scroll
const lenis = new Lenis({
  smoothWheel: true, // Smooth wheel behavior
  smoothTouch: false, // Disable smooth touch scrolling (if needed)
  normalizeWheel: true, // Normalize wheel events
  // Ignore elements with the class 'scroll-section' (or any other class you use)
  ignore: (el) => el.classList.contains("scroll-section"),
});

lenis.on("scroll", ScrollTrigger.update);
gsap.ticker.add((time) => {
  lenis.raf(time * 700);
});

gsap.ticker.lagSmoothing(0);
 
// --- smooth scroll --------------


// card image update

// function cardImageUpdate(el,newUrl){
//   const card = el.closest(".card");
//   console.log(card.querySelector(".fixed-image"))
//   card.querySelector(".fixed-image").setAttribute("src",newUrl)
// }
// function cardImageUpdate(el, newUrl) {
//   const card = el.closest(".card");

//   // Update image
//   card.querySelector(".fixed-image").setAttribute("src", newUrl);

//   // Remove class from all swatches in this card
//   const allSwatches = card.querySelectorAll(".pdp-swatch-item");
//   allSwatches.forEach(item => item.classList.remove("pdp-itself"));

//   // Add class to clicked one
//   el.classList.add("pdp-itself");
// }
function cardImageUpdate(el, newUrl, newLink) {
  const card = el.closest(".card");

  // Image update
  card.querySelector(".fixed-image").setAttribute("src", newUrl);

  // ✅ Correct link update
  const productLink = card.querySelector(".product-title-link");
  if (productLink) {
    productLink.href = newLink;
  }

  // Active class
  const allSwatches = card.querySelectorAll(".pdp-swatch-item");
  allSwatches.forEach(item => item.classList.remove("pdp-itself"));

  el.classList.add("pdp-itself");
}
// card image update

// pdp swatch hover

function pdpSwatchHover(title){
  document.querySelector(".pdp-swatch-name").textContent = title.trim();
}
function mouseLeaveSwatch(){
  // document.querySelector(".pdp-swatch-name").textContent = "";
  document.querySelector(".pdp-swatch-name").textContent = document.querySelector(".pdp-swatch-item.pdp-itself").getAttribute("data-color").trim();
}

// pdp swatch hover


// ------ scroll to top when click on footer logo --------
document.addEventListener("DOMContentLoaded", function () {

 const logoWeb = document.querySelector('.footer-logo');
  logoWeb?.addEventListener('click', () => {
    lenis.scrollTo(0, {
      duration: 1.25,
      easing: (t) => t * (2 - t)
    });
  });
});

// ------ scroll to top when click on footer logo --------

// ====== date and time ======

async function getUserLocationAndTimeZone() {
  try {
    // Fetch user's IP-based location info
    const response = await fetch("https://ipapi.co/json/");
    const data = await response.json();

    const timeZone =
      data.timezone || Intl.DateTimeFormat().resolvedOptions().timeZone;
    const locationName = `${data.city?.toUpperCase() || "UNKNOWN"}, ${
      data.country_name?.toUpperCase() || ""
    }`;

    function updateDateTime() {
      const now = new Date();

      const weekday = now
        .toLocaleDateString("en-US", {
          weekday: "long",
          timeZone: timeZone,
        })
        .toUpperCase();

      const datePart = now
        .toLocaleDateString("en-US", {
          month: "numeric",
          day: "numeric",
          year: "numeric",
          timeZone: timeZone,
        })
        .replace(/\//g, ".");

      const timePart = now.toLocaleTimeString("en-GB", {
        hour12: false,
        timeZone: timeZone,
      });

      document.getElementById("date").innerText = `${weekday}, ${datePart}`;
      document.getElementById("time").innerText = `${timePart} ${locationName}`;
    }

    updateDateTime();
    setInterval(updateDateTime, 1000);
  } catch (err) {
    document.body.innerHTML =
      "Failed to get location. Please check your internet connection.";
    console.error("Error fetching location/timezone:", err);
  }
}

if (
  window.location.pathname === "/" ||
  window.location.pathname === "/index.html"
) {
  // getUserLocationAndTimeZone();
}

// ====== date and time ======



// ====== collection grid ======

document.addEventListener("DOMContentLoaded", function () {
  const items = document.querySelectorAll(
    ".cust_col_main .col_hero .hero_grid .grid_box ul li"
  );

  items.forEach((item) => {
    item.addEventListener("click", () => {
      // Remove active class from all
      items.forEach((el) => el.classList.remove("active"));

      // Add active to the clicked one
      item.classList.add("active");
    });
  });
});

// ====== collection grid ======




// -------------- header effect while scroll --------------

document.addEventListener('DOMContentLoaded', function () {
  const navbar = document.querySelector('.header-main .navbar');
    if (!location.pathname.includes('/products') && !location.pathname.includes('/cart') && !location.pathname.includes('/collections') && !location.pathname.includes('/pages') && !location.pathname.includes('/policies') && !location.pathname.includes('/search') ) {
    
    function handleScroll() {
      if (window.scrollY != 0) {
        if(!navbar.classList.contains("addBg")){
        navbar.classList.add('addBg');
        setTimeout(() => {
          navbar.classList.add('addCut');
        }, 200);
      }
      } else {
        navbar.classList.remove('addCut');
        setTimeout(() => {
          navbar.classList.remove('addBg');
        }, 200);
      }
    }
    
    // Check on page load
    handleScroll();
    
    // Check on scroll
    window.addEventListener('scroll', handleScroll);
  } else {
    navbar.classList.add('addBg');
      setTimeout(() => {
      navbar.classList.add('addCut');
    }, 200);
  }
  });
// -------------- header effect while scroll --------------

// =============== SIZE CHART ================


// const sizeChartModal = document.getElementById('sizeChartModal');
// const sizeChartOverlay = document.getElementById('overlay');

const openSizeChartModal = function(pInfo) {
  const mainSC = pInfo.querySelector("#sizeChartModal");
  const mainOverL = pInfo.querySelector(".product__description #overlay");
  mainSC.style.display = 'block';
  mainOverL.style.display = 'block';
  mainOverL.addEventListener("click",()=>{
    closeSizeChartModal(pInfo);
  })
};

const closeSizeChartModal = function(pInfo) {
   const mainSC = pInfo.querySelector("#sizeChartModal");
    const mainOverL = pInfo.querySelector(".product__description #overlay");

  mainSC.style.display = 'none';
  mainOverL.style.display = 'none';
};

document.addEventListener('click', function(event) {
  if (event.target.closest('.size-chart-btn')) {
    const pInfo = event.target.closest("product-info");
    openSizeChartModal(pInfo);
  }
  if (event.target.closest('.close-btn')) {
    const pInfo = event.target.closest("product-info");
    closeSizeChartModal(pInfo);
  }
});

document.addEventListener('keydown', function(event) {
  if (event.key === "Escape" && sizeChartModal && sizeChartModal.style.display === 'block') {
    closeSizeChartModal();
  }
});

// =============== SIZE CHART ================




// ============ SUBMENU IN MOBLIE ==================
const mainMenu = document.querySelector('.main-menu');

// OPEN SUBMENU
document.querySelectorAll('.main-menu .has-submenu').forEach(item => {

  item.addEventListener('click', function () {

    const text = this.querySelector('p')
      .childNodes[0]
      .textContent
      .trim()
      .toLowerCase();

    const submenuMap = {
      "shop": "submenu-shop",
      "chapters": "submenu-chapters"
    };

    const targetSubmenu = document.getElementById(submenuMap[text]);

    if (!targetSubmenu) return;

    // Slide main menu left
    mainMenu.classList.add('slide-left');

    // Open submenu
    targetSubmenu.classList.add('open');

  });

});
// CLOSE SUBMENU
document.querySelectorAll('.submenu .close_submenu').forEach(btn => {
  btn.addEventListener('click', function () {

    const submenu = this.closest('.submenu');

    // Close submenu
    submenu.classList.remove('open');
    submenu.classList.add('slide-right-out');

    // Bring main menu back
    mainMenu.classList.remove('slide-left');

    // Reset submenu after animation
    setTimeout(() => {
      submenu.classList.remove('slide-right-out');
    }, 350);
  });
});


// ============ SUBMENU IN MOBLIE ==================



// =============== hamburger =================

const toggleBtn = document.querySelector('.toggle-btn-d');
const mobileMenu = document.querySelector('.head_ham_container');
const menuOverlay = document.querySelector('.menu-overlay'); // Make sure this exists in HTML

function menuOpen() {
  toggleBtn.classList.toggle('active');
  mobileMenu.classList.toggle('active-cont');
  menuOverlay?.classList.toggle('active'); // optional chaining in case it's null

  // Prevent body scroll when menu is open
  if (mobileMenu.classList.contains('active-cont')) {
    document.body.style.overflow = 'hidden';
  } else {
    document.body.style.overflow = '';
  }
}

// Only one event listener is needed
toggleBtn.addEventListener('click', menuOpen);

// =============== hamburger =================


function cardImageUpdate(el, mainImage, hoverImage, productUrl) {

    const card = el.closest('.card-wrapper');

    card.querySelectorAll('.pdp-swatch-item').forEach(item => {
        item.classList.remove('pdp-itself');
    });

    el.classList.add('pdp-itself');

    const primary = card.querySelector('.card__image-primary');
    const secondary = card.querySelector('.card__image-secondary');

    if (primary) primary.src = mainImage;
    if (secondary && hoverImage) secondary.src = hoverImage;

    card.querySelectorAll('a').forEach(link => {
        if (link.href) {
            link.href = productUrl;
        }
    });
}